import { titleCase } from 'title-case'

export const formatTitleCase = (str: string | null | undefined): string => {
    if (!str) {
        return ''
    }

    return titleCase(str)
}
